export default "__VITE_ASSET__CxKXRG4M__"